import type { TranslationCatalog } from "../TranslationManager";

export const th: TranslationCatalog = {
  "labels.cardNumber": "หมายเลขบัตร",
  "labels.expirationDate": "วันหมดอายุ",
  "labels.cvc": "รหัสความปลอดภัย",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "ดด / ปป",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "หมายเลขบัตรของคุณไม่ถูกต้อง",
  "errors.invalidExpiryDate": "วันหมดอายุบัตรของคุณไม่ถูกต้อง",
  "errors.invalidCvc": "รหัสความปลอดภัยของบัตรไม่ถูกต้อง",
  "errors.incompleteCardNumber": "หมายเลขบัตรของคุณไม่สมบูรณ์",
  "errors.incompleteExpiryDate": "วันหมดอายุบัตรของคุณไม่สมบูรณ์",
  "errors.incompleteCvc": "รหัสความปลอดภัยของบัตรไม่สมบูรณ์",
  "errors.expiredCard": "บัตรของคุณหมดอายุแล้ว",
  "aria.cardNumber": "หมายเลขบัตร",
  "aria.expirationDate": "วันหมดอายุ",
  "aria.cvc": "รหัสความปลอดภัย",
  "aria.cardInput": "ข้อมูลบัตร",
};
